// extracted by mini-css-extract-plugin
module.exports = {"input":"TimeInput_input__2E791","small":"TimeInput_small__1vsop","text-attention":"TimeInput_text-attention__3k21B"};